<!-- Content -->
@if (content()) {
  <div class="content" #contentEl [innerHTML]="content()"></div>
}

<!-- Media (only images are supported for now) -->
@if (media() != null) {
  <figure class="media">
    <img [alt]="media().fileName" [src]="imageUrl()" />
  </figure>
}
